import { LazyLoadWrapper } from "features/Common/LazyLoadWrapper/LazyLoadWrapper";
import React from "react";
import { DisputeHistory } from "./DisputeHistory";

export const LazyLoadedDisputeHistory = (props) => {
  return (
    <LazyLoadWrapper loadingCondition={props}>
      <DisputeHistory {...props} />
    </LazyLoadWrapper>
  );
};
